var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOauthGrant = function SvgOauthGrant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.6 7.63V9.48m0-1.851V3.185c0-.613.507-1.11 1.133-1.11s1.134.497 1.134 1.11M4.6 7.63c0-.614-.507-1.111-1.133-1.111s-1.134.497-1.134 1.11v1.482c0 2.378 1.524 4.407 3.667 5.2m.867-11.126V7.26m0-4.074v-.74c0-.614.507-1.112 1.133-1.112s1.133.498 1.133 1.111v.741m0 0V7.26m0-4.074c0-.613.508-1.11 1.134-1.11s1.133.497 1.133 1.11v2.222m0 0V7.26m0-1.852c0-.613.507-1.11 1.133-1.11s1.134.497 1.134 1.11V7.26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oauth-grant_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M12.667 11a.665.665 0 0 0-.667-.667M12 13a2 2 0 1 0-1.982-1.731c.02.145.03.217.023.263a.3.3 0 0 1-.04.115c-.022.04-.062.08-.141.16l-1.704 1.704c-.057.057-.086.086-.107.12a.3.3 0 0 0-.04.096c-.009.038-.009.08-.009.16v.58c0 .186 0 .28.036.351a.33.33 0 0 0 .146.146c.071.036.165.036.351.036h.8v-.667H10v-.666h.667l.526-.527c.08-.08.12-.119.16-.142a.3.3 0 0 1 .115-.039c.046-.006.118.004.263.023Q11.863 13 12 13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oauth-grant_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 8h8v8H7z"
  })))));
};
export default SvgOauthGrant;